import Swal from "sweetalert2";

const baseToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

const Toast = {
  success: (message) =>
    baseToast.fire({
      icon: "success",
      title: message,
    }),

  error: (message) =>
    baseToast.fire({
      icon: "error",
      title: message,
    }),

  warning: (message) =>
    baseToast.fire({
      icon: "warning",
      title: message,
    }),

  info: (message) =>
    baseToast.fire({
      icon: "info",
      title: message,
    }),
};

export default Toast;
